import React from 'react';
import * as C from "../componentsM/index"

const ApproachesToLearn = () => {
    return (
        <>

            <C.Hero title={"APPROACHES TO LEARNING (ATL)"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>Through Approaches to Learning (ATL) in IB programmes, students develop skills that have relevance across the curriculum that help them “learn how to learn”. ATL skills can be learned and taught, improved with practice and developed incrementally. They provide a solid foundation for learning independently and with others. ATL skills help students prepare for, and demonstrate learning through, meaningful assessment.</p>

                    <p>They provide a common language that students and teachers can use to reflect on, and articulate on, the process of learning. IB programmes identify five ATL skill categories, expanded into developmentally appropriate skill clusters:</p>


                    <figure className='mx-auto md:w-[50%]'>
                        <img src="/atl.jpg" className='w-full h-full object-contain' />
                    </figure>



                </div>
            </section>

        </>

    )
}

export default ApproachesToLearn